import React, { useEffect, useState } from "react";
import { CategoryData } from "../../AllDatas/categoryData";
import { CategoryiIcon } from "../../assets/icons";
import { COLORS } from "../../constants/colors";
import GreyText from "../GreyText/greyText";
import Title from "../Title/title";
import styles from "./category.module.css";
import { useDispatch, useSelector } from "react-redux";
import { Dispatch, RootState } from "../../store";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { omitBy, isUndefined } from "lodash";

const Category = (handlePagination: any) => {
  const navigate = useNavigate();
  const [category_id, setCategory] = useState(0);

  const dispatch = useDispatch<Dispatch>();

  useEffect(() => {
    dispatch.categorySlice.getCategory();
  }, []);

  const { categoryList } = useSelector(
    (state: RootState) => state.categorySlice
  );

  const { id } = useParams();

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <CategoryiIcon />
        <Title
          fontSize="22px"
          style={{
            marginLeft: "10px",
            color: "#000",
            fontFamily: "FuturaPTMedium",
          }}
          title="Категории"
        />
      </div>
      <div className={styles.category}>
        <GreyText
          style={{
            margin: "12px 0",
            cursor: "pointer",
            fontSize: "20px",
            fontFamily: "FuturaPTMedium",

            color: category_id === 0 ? COLORS.orange : "#000",
          }}
          hover={true}
          text="Все Товары"
          onPress={() => {
            dispatch.OtherSlice.setCategoryIdValue(0);
            dispatch.productSlice.getProduct({
              shop_id: id,
              category_id: 0,
              page: 1,
            });
            setCategory(0);
          }}
        />
        {categoryList.map((e, index) => {
          return (
            <GreyText
              key={index}
              style={{
                margin: "9px 0",
                cursor: "pointer",
                fontSize: "20px",
                fontFamily: "FuturaPTMedium",

                color: category_id === e.id ? COLORS.orange : "#000",
              }}
              hover={true}
              text={e.name}
              onPress={() => {
                setCategory(e.id);
                dispatch.OtherSlice.setCategoryIdValue(e.id);
                dispatch.productSlice.getProduct({
                  shop_id: id,
                  category_id: e.id,
                  page: 1,
                });
              }}
            />
          );
        })}
      </div>
    </div>
  );
};

export default Category;
